import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchAdminCandidates,
  updateAdminCandidateStatus,
  exportAdminCandidateGdpr,
  deleteAdminCandidateGdpr,
  type AdminCandidate,
  type AdminCandidateStatus,
  type CandidateFilters,
} from '../api/adminCandidates';

export function useAdminCandidates(filters: CandidateFilters) {
  return useQuery<AdminCandidate[]>({
    queryKey: ['admin-candidates', filters],
    queryFn: () => fetchAdminCandidates(filters),
    staleTime: 1000 * 30,
  });
}

export function useAdminCandidateAction(filters: CandidateFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status, note }: { id: string; status: AdminCandidateStatus; note?: string }) =>
      updateAdminCandidateStatus(id, status, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-candidates', filters] });
    },
  });
}

export function useAdminCandidateGdprExport() {
  return useMutation({
    mutationFn: async (id: string) => exportAdminCandidateGdpr(id),
  });
}

export function useAdminCandidateGdprDelete(filters: CandidateFilters) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => deleteAdminCandidateGdpr(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-candidates', filters] });
    },
  });
}
